module.exports = __webpack_public_path__ + "img/sd1.e631fa19.png";